export default {
  'userPermission': 'COMPANY_ADMIN',
  'publicationsCount':3,
  'user': {
    'username': 'admin+company@3dissue.com',
    'email': 'admin+company@3dissue.com',
    'fullname': '3D Issue Company Super Admin',
    'oauth_apikey': '',
    'url': '99bae6a47c4f13aac72f38b',
    'account_registered': true,
    'account_expired_ts': null,
    'hubs_limit': null,
    'sources_limit': null,
    'account_expired': false,
    'billing_plan': 'ent'
  },
  'publications': [
    {
      'id': '7x98QOdi',
      'date_created': '2017-06-27 09:18:54',
      'last_updated': '2017-06-27 09:19:14',
      'title': 'IHB-1489',

      'screenshot_url': 'https:\/\/s3.amazonaws.com\/hubs-images-test\/users\/' +
        '99bae6a47c4f13aac72f38b\/screenshots\/1286',

      'icon_set_id': null,
      'type': 1,
      'disabled': null,
      'layout': {

        // WARN Added property
        'type': 'letter',

        'favicon': null,
        'publication_id': 1286,
        'logo_image': null,
        'background_image': null,
        'background_blur':5,
        'menu_text_color': 'rgb(255, 255, 255)',
        'menu_background_color': 'rgb(37, 38, 39)',
        'sidebar_font': null,
        'section_title_font': null,
        'items_index_font': null,
        'item_title_font': null,
        'item_date_font': null,
        'item_body_font': null,
        'more_button_font': null,
        'hide_sidebar': 0,
        'background_color': null,
        'hide_tile_labels': 1,
        'newswall_tile_width': 290,
        'home_color': null,
        'home_icon_id': null,
        'home_icon_outer_size':40,
        'home_icon_inner_size': 290,
        'home_icon_shape': 'square',
        'home_icon_use_bg_color': null,
        'home_icon_bg_color': '0',
        'home_icon_border': null,
        'home_icon_use_svg_color': null,
        'home_icon_svg_color': null,
        'hide_content_type_icons': 0,
        'article_intro_images': 1,
        'show_filler_images': 1,
        'hide_header': 0,
        'show_menu_bar': 0,
        'full_screen': 0,
        'hide_right_columns': 0,
        'header_image': null,
        'header_color': null,
        'text_color': null,
        'hover_color': null,
        'hide_disqus': 0,
        'hide_search': 0,
        'hide_social': 0
      },
      'sections': [
        {
          'id': 2265,
          'title': 'Main',
          'sortorder': '1',
          'color': '#141415',
          'type': 'mixed',
          'icon': null,
          'sources': [
            {
              id        : 20,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/1.jpeg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'Superbowl party in the Woolshed Baa & Grill',
              text      : 'Some text goes here',
            },

            {
              id        : 21,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/2.jpeg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'Best pubs in Dublin for a pint of the black stuff',

              text: 'No visit to Dublin is complete without spending some time in a few of the city’s iconic pubs. Here you’ll\
                exper ience first-hand the hospitality and friendless for which the Irish are renowned, as well as possibly\
                getting the chance to listen to some wonderful traditional folk music. We list 10 of the best watering holes\
                in the Irish capital.',

              x: 1,
              y: 0,
            },

            {
              id        : 22,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/3.jpeg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'There`s a cool new craft beer mural on the side of a Dublin',
              text      : 'Some text goes here',
            },

            {
              id        : 23,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/4.jpeg',
              rows      : 1,
              section   : 'Untitled',
              name      : '12 pubs for great after work drinks in Dublin',

              text: 'We’ve made this selection of pubs to have after work drinks and food based on a few criteria. One of the most important is\
                that the pub be large enough so that there’s plenty of space to fit larger groups of people. All of them have finger food\
                options, and can cater for parties big and small.',
            },

            {
              id        : 24,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/5.jpg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'Highland Brewing Launches Brand Refresh',
              text      : 'Some text goes here',
            },

            {
              id        : 25,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/6.jpg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'TRVE Brewing to Release First Spontaneous Beer',
            },

            {
              id        : 26,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/7.jpg',
              rows      : 1,
              section   : 'Untitled',
              name      : 'Founders Brewing Co. to Release CBS',
              text      : 'Some text goes here',
            },

            {
              id        : 27,
              cols      : 1,
              created   : '2017-06-27 09:18:54',
              avatar_url: '/assets/images/8.png',
              rows      : 1,
              section   : 'Untitled',
              name      : '2017 Great American Beer Festival Winners',
            },],
          'subsections': [
            {
              'id': 33,
              'title': 'Introduction',

              'sources': [
                {
                  // WARN Added properties
                  'id': 1,
                  'created': '2017-06-27 09:18:54',

                  'name': '3dissue.com vvv',
                  'url': 'https:\/\/www.3dissue.com\/feed',
                  'type': 'feed',
                  'owner': 1,
                  'enabled': 1,
                  'username': null,
                  'source_id': 1235,
                  'filter': null,
                  'own_feed_flag': 0,
                  'favourites_flag': 0,
                  'playlists_flag': 0,
                  'likes_flag': 0,
                  'include_in_all_flag': 1,
                  'hide_new_entries_flag': 0,
                  'source_featured_flag': 0,
                  'featured_period': 1,
                  'featured_period_started_ts': null,
                  'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
                  'last_parsed': '2018-02-08 12:36:52',
                  'parameters': null,
                  'added_to_parse': false,
                  'cols': 1,
                  'rows': 1,
                  'x': 0,
                  'y': 0,
                },
                {
                  'id': 2,
                  'name': 'Milan Design Week 2017',
                  'created': '2017-06-27 09:18:54',
                  'url': 'https:\/\/www.pinterest.com\/wearedeltalight\/milan-design-week-2017\/',
                  'type': 'pinterest',
                  'owner': 0,
                  'enabled': 1,
                  'username': 'wearedeltalight',
                  'source_id': 1248,
                  'filter': null,
                  'own_feed_flag': 0,
                  'favourites_flag': 0,
                  'playlists_flag': 0,
                  'likes_flag': 0,
                  'include_in_all_flag': 1,
                  'hide_new_entries_flag': 0,
                  'source_featured_flag': 0,
                  'featured_period': 1,
                  'featured_period_started_ts': null,

                  'avatar_url': 'http:\/\/i.pinimg.com\/upload\/401805666694006838_board_thumbnail' +
                    '_2017-04-26-06-52-20_93790_60.jpg',

                  'last_parsed': '2018-02-08 12:28:03',
                  'parameters': null,
                  'added_to_parse': false,
                  'cols': 1,
                  'rows': 1,
                  'x': 1,
                  'y': 0,
                }
              ],
            },

            {'id': 35, 'title': 'Story', 'sources': []},
          ],
          'date_created': '2017-06-27 09:18:54',
          'last_updated': '2017-06-27 09:18:54',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': '40',
          'icon_inner_size': '100',
          'icon_shape': 'square',
          'icon_use_bg_color': '0',
          'icon_border': '',
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1286\/sections\/2266\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1286\/section\/2266?format=rss',
          'parent_id': null
        },
        {
          'id': 2266,
          'title': 'Untitled 1',
          'sortorder': '1',
          'color': '#141415',
          'type': 'mixed',
          'icon': null,
          'sources': [],

          'subsections': [
            {
              'id': 3377,
              'title': 'There is a subsection',

              'sources': [
                {
                  'id': 3,
                  'name': 'Auto Show, Tokyo',
                  'created': '2017-06-27 09:18:54',
                  'url': 'https:\/\/www.3dissue.com\/feed',
                  'type': 'feed',
                  'owner': 1,
                  'enabled': 1,
                  'username': null,
                  'source_id': 1235,
                  'filter': null,
                  'own_feed_flag': 0,
                  'favourites_flag': 0,
                  'playlists_flag': 0,
                  'likes_flag': 0,
                  'include_in_all_flag': 1,
                  'hide_new_entries_flag': 0,
                  'source_featured_flag': 0,
                  'featured_period': 1,
                  'featured_period_started_ts': null,
                  'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
                  'last_parsed': '2018-02-08 12:36:52',
                  'parameters': null,
                  'added_to_parse': false,
                  'cols': 1,
                  'rows': 1,
                  'x': 0,
                  'y': 0,
                },
                {
                  'id': 4,
                  'name': 'Milan Design Week 2017',
                  'created': '2017-06-27 09:18:54',
                  'url': 'https:\/\/www.pinterest.com\/wearedeltalight\/milan-design-week-2017\/',
                  'type': 'pinterest',
                  'owner': 0,
                  'enabled': 1,
                  'username': 'wearedeltalight',
                  'source_id': 1248,
                  'filter': null,
                  'own_feed_flag': 0,
                  'favourites_flag': 0,
                  'playlists_flag': 0,
                  'likes_flag': 0,
                  'include_in_all_flag': 1,
                  'hide_new_entries_flag': 0,
                  'source_featured_flag': 0,
                  'featured_period': 1,
                  'featured_period_started_ts': null,

                  'avatar_url': 'http:\/\/i.pinimg.com\/upload\/401805666694006838_board_thumbnail' +
                    '_2017-04-26-06-52-20_93790_60.jpg',

                  'last_parsed': '2018-02-08 12:28:03',
                  'parameters': null,
                  'added_to_parse': false,
                  'cols': 1,
                  'rows': 1,
                  'x': 0,
                  'y': 1,
                }
              ]
            },
          ],

          'date_created': '2017-06-27 09:18:54',
          'last_updated': '2017-06-27 09:18:54',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': '40',
          'icon_inner_size': '100',
          'icon_shape': 'square',
          'icon_use_bg_color': '0',
          'icon_border': '',
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1286\/sections\/2266\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1286\/section\/2266?format=rss',
          'parent_id': null
        },

        {
          'id': 22677,
          'title': 'No subsections',
          'subsections': [],
          'sortorder': '1',
          'color': '#141415',
          'type': 'mixed',
          'icon': null,
          'sources': [
            {
              'id': 5,
              'name': 'Some interesting feed',
              'created': '2017-06-27 09:18:54',
              'url': 'https:\/\/www.3dissue.com\/feed',
              'type': 'feed',
              'owner': 1,
              'enabled': 1,
              'username': null,
              'source_id': 1235,
              'filter': null,
              'own_feed_flag': 0,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,
              'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
              'last_parsed': '2018-02-08 12:36:52',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 0,
              'y': 0,
            },
            {
              'id': 6,
              'name': 'New York Fashion Week 2018',
              'created': '2017-06-27 09:18:54',
              'url': 'https:\/\/www.pinterest.com\/wearedeltalight\/milan-design-week-2017\/',
              'type': 'pinterest',
              'owner': 0,
              'enabled': 1,
              'username': 'wearedeltalight',
              'source_id': 1248,
              'filter': null,
              'own_feed_flag': 0,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,

              'avatar_url': 'http:\/\/i.pinimg.com\/upload\/401805666694006838_board_thumbnail' +
                '_2017-04-26-06-52-20_93790_60.jpg',

              'last_parsed': '2018-02-08 12:28:03',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 1,
              'y': 3,
            }
          ],
          'date_created': '2017-06-27 09:18:54',
          'last_updated': '2017-06-27 09:18:54',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': '40',
          'icon_inner_size': '100',
          'icon_shape': 'square',
          'icon_use_bg_color': '0',
          'icon_border': '',
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1286\/sections\/2266\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1286\/section\/2266?format=rss',
          'parent_id': null
        },
      ],
      'readonly': null,
      'url': 'https:\/\/test-hubs.3dissue.net\/7x98QOdi',
      'rss_url': 'https:\/\/test-hubs.3dissue.net\/7x98QOdi?format=rss',
      'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/7x98QOdi\/items'
    },
    {
      'id': '0UTe0ZAW',
      'date_created': '2017-06-26 15:46:52',
      'last_updated': '2017-06-26 15:46:52',
      'title': 'ввв',

      'screenshot_url': 'https:\/\/s3.amazonaws.com\/hubs-images-test\/users\/99bae6a47c4f13aac72f38b\/' +
        'screenshots\/1276',

      'icon_set_id': null,
      'type': 2,
      'disabled': null,
      'layout': {
        'type': 'wall',
        'favicon': null,
        'publication_id': 1276,
        'logo_image': null,
        'background_image': null,
        'background_blur':5,
        'menu_text_color': 'rgb(255, 255, 255)',
        'menu_background_color': 'rgb(37, 38, 39)',
        'sidebar_font': null,
        'section_title_font': null,
        'items_index_font': null,
        'item_title_font': null,
        'item_date_font': null,
        'item_body_font': null,
        'more_button_font': null,
        'hide_sidebar': 0,
        'background_color': null,
        'hide_tile_labels': 1,
        'newswall_tile_width': 290,
        'home_color': null,
        'home_icon_id': null,
        'home_icon_outer_size':40,
        'home_icon_inner_size': 290,
        'home_icon_shape': 'square',
        'home_icon_use_bg_color': null,
        'home_icon_bg_color': '0',
        'home_icon_border': null,
        'home_icon_use_svg_color': null,
        'home_icon_svg_color': null,
        'hide_content_type_icons': 0,
        'article_intro_images': 1,
        'show_filler_images': 1,
        'hide_header': 0,
        'show_menu_bar': 0,
        'full_screen': 0,
        'hide_right_columns': 0,
        'header_image': null,
        'header_color': null,
        'text_color': null,
        'hover_color': null,
        'hide_disqus': 0,
        'hide_search': 0,
        'hide_social': 0
      },
      'sections': [
        {
          'id': 2248,
          'title': 'Untitled 1',
          'sortorder': '1',
          'color': '#141415',
          'type': 'articles',
          'icon': null,
          'sources': [
            {
              'id': 7,
              'name': 'Auto Show, Tokyo',
              'created': '2017-06-27 09:18:54',
              'url': 'https:\/\/www.3dissue.com\/feed',
              'type': 'feed',
              'owner': 1,
              'enabled': 1,
              'username': null,
              'source_id': 1235,
              'filter': null,
              'own_feed_flag': 0,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,
              'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
              'last_parsed': '2018-02-08 12:36:52',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 1,
              'y': 0,
            }
          ],
          'subsections': [

          ],
          'date_created': '2017-06-26 15:46:53',
          'last_updated': '2017-06-26 15:46:53',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': '40',
          'icon_inner_size': '100',
          'icon_shape': 'square',
          'icon_use_bg_color': '0',
          'icon_border': '',
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1276\/sections\/2248\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1276\/section\/2248?format=rss',
          'parent_id': null
        }
      ],
      'readonly': null,
      'url': 'https:\/\/test-hubs.3dissue.net\/0UTe0ZAW',
      'rss_url': 'https:\/\/test-hubs.3dissue.net\/0UTe0ZAW?format=rss',
      'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/0UTe0ZAW\/items'
    },
    {
      'id': 'bGahfpPr',
      'date_created': '2017-06-01 08:50:48',
      'last_updated': '2017-06-01 08:50:48',
      'title': 'Great Shout for Stout',

      'screenshot_url': 'https:\/\/s3.amazonaws.com\/hubs-images-test\/users\/99bae6a47c4f13aac72f38b\/' +
        'screenshots\/1167',

      'icon_set_id': null,
      'type': 2,
      'disabled': null,
      'layout': {
        'type': 'wall',
        'favicon': '',
        'publication_id': 1167,

        'logo_image': 'https:\/\/s3.amazonaws.com\/hubs-images-test\/users\/54ab317acec5df50dc1872c\/layout\/logos\/' +
          '1167.Untitled-1',

        'background_image': '',
        'background_blur':5,
        'menu_text_color': 'rgb(0, 0, 0)',
        'menu_background_color': 'rgb(37, 38, 39)',
        'sidebar_font': null,
        'section_title_font': null,
        'items_index_font': null,
        'item_title_font': null,
        'item_date_font': null,
        'item_body_font': null,
        'more_button_font': null,
        'hide_sidebar': 0,
        'background_color': 'rgb(0, 0, 0)',
        'hide_tile_labels': 1,
        'newswall_tile_width': 290,
        'home_color': null,
        'home_icon_id': null,
        'home_icon_outer_size':40,
        'home_icon_inner_size': 290,
        'home_icon_shape': 'square',
        'home_icon_use_bg_color': null,
        'home_icon_bg_color': '0',
        'home_icon_border': null,
        'home_icon_use_svg_color': null,
        'home_icon_svg_color': null,
        'hide_content_type_icons': 0,
        'article_intro_images': 1,
        'show_filler_images': 1,
        'hide_header': 0,
        'show_menu_bar': 0,
        'full_screen': 0,
        'hide_right_columns': 0,
        'header_image': null,
        'header_color': null,
        'text_color': null,
        'hover_color': null,
        'hide_disqus': 0,
        'hide_search': 0,
        'hide_social': 0
      },
      'sections': [
        {
          'id': 2071,
          'title': 'Reviews',
          'sortorder': '1',
          'color': '#141415',
          'type': 'articles',
          'icon': null,
          'sources': [
            {
              'id': 8,
              'name': 'greatshoutforstout.com',
              'created': '2017-06-27 09:18:54',
              'url': 'http:\/\/www.greatshoutforstout.com\/feed',
              'type': 'feed',
              'owner': 1,
              'enabled': 0,
              'username': null,
              'source_id': 1157,
              'filter': null,
              'own_feed_flag': 0,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,
              'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=http:\/\/www.greatshoutforstout.com\/feed',
              'last_parsed': '2017-06-16 00:03:51',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 1,
              'y': 1,
            }
          ],
          'subsections': [

          ],
          'date_created': '2017-06-01 08:50:48',
          'last_updated': '2017-06-01 08:51:16',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': null,
          'icon_inner_size': null,
          'icon_shape': null,
          'icon_use_bg_color': null,
          'icon_border': null,
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1167\/sections\/2071\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1167\/section\/2071?format=rss',
          'parent_id': null
        },
        {
          'id': 2072,
          'title': 'Facebook',
          'sortorder': '2',
          'color': '#141415',
          'type': 'facebook',
          'icon': null,
          'sources': [
            {
              'id': 9,
              'name': 'Great Shout for Stout',
              'created': '2017-06-27 09:18:54',
              'url': 'https:\/\/www.facebook.com\/233568383412188',
              'type': 'public-facebook',
              'owner': 1,
              'enabled': 1,
              'username': '233568383412188',
              'source_id': 1158,
              'filter': null,
              'own_feed_flag': 1,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,
              'avatar_url': 'https:\/\/graph.facebook.com\/v2.7\/233568383412188\/picture?width=150&amp;height=150',
              'last_parsed': '2018-02-08 12:28:04',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 3,
              'y': 3,
            }
          ],
          'subsections': [

          ],
          'date_created': '2017-06-01 08:51:13',
          'last_updated': '2017-06-01 08:51:20',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': null,
          'icon_inner_size': null,
          'icon_shape': null,
          'icon_use_bg_color': null,
          'icon_border': null,
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1167\/sections\/2072\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1167\/section\/2072?format=rss',
          'parent_id': null
        },
        {
          'id':3839,
          'title': 'Flipbooks',
          'sortorder': '3',
          'color': '#141415',
          'type': 'flipbook',
          'icon': null,
          'sources': [
            {
              'id': 10,
              'name': 'Flipbook',
              'created': '2017-06-27 09:18:54',
              'url': 'https:\/\/samples.3dissue.com\/flipbooks\/magazine-samples\/library.xml',
              'type': 'flipbook',
              'owner': 0,
              'enabled': 1,
              'username': null,
              'source_id':3175,
              'filter': [
                '3D Issue Samples'
              ],
              'own_feed_flag': 0,
              'favourites_flag': 0,
              'playlists_flag': 0,
              'likes_flag': 0,
              'include_in_all_flag': 1,
              'hide_new_entries_flag': 0,
              'source_featured_flag': 0,
              'featured_period': 1,
              'featured_period_started_ts': null,

              'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/samples.3dissue.com\/' +
                'flipbooks\/magazine-samples\/library.xml',

              'last_parsed': '2018-02-08 12:28:27',
              'parameters': null,
              'added_to_parse': false,
              'cols': 1,
              'rows': 1,
              'x': 1,
              'y': 0,
            }
          ],
          'subsections': [

          ],
          'date_created': '2017-09-25 14:13:20',
          'last_updated': '2017-09-25 14:13:28',
          'use_icon_defaults': '1',
          'icon_id': null,
          'icon_outer_size': '40',
          'icon_inner_size': '100',
          'icon_shape': 'square',
          'icon_use_bg_color': '0',
          'icon_border': '',
          'icon_use_svg_color': null,
          'icon_svg_color': null,
          'icon_border_width': '',
          'icon_border_style': '',
          'icon_border_color': '',
          'use_icon_border': '0',
          'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1167\/sections\/3839\/items',
          'rss_url': 'https:\/\/test-hubs.3dissue.net\/1167\/section\/3839?format=rss',
          'parent_id': null
        }
      ],
      'readonly': null,
      'url': 'https:\/\/test-hubs.3dissue.net\/bGahfpPr',
      'rss_url': 'https:\/\/test-hubs.3dissue.net\/bGahfpPr?format=rss',
      'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/bGahfpPr\/items'
    }
  ]
};



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/fixtures/publications.ts